import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=6e631c71&"
import script from "./InquiryForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryForm.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports